import { useEffect } from "react";

import useOpenGuestSignIn from "./useOpenGuestSignIn";

type GuestSignInOptions = {
  readonly isEnabled: boolean;
};

/** Opens the sign in overlay as soon as a logged out reader lands on a page that has nothing to show them. */
export default function useGuestSignIn({ isEnabled }: GuestSignInOptions): void {
  const openGuestSignIn = useOpenGuestSignIn();
  useEffect(() => {
    if (isEnabled) {
      openGuestSignIn();
    }
  }, [isEnabled, openGuestSignIn]);
}
